// custom-options.js — Royal Ranch embroidery customizer interactions.
//
// 1. Live char counter for any [data-validated-text-input] (Patch Text, Name
//    Text, Embroidered Text). Counter element is the colocated [data-char-counter]
//    referenced via the input's aria-describedby.
// 2. File-upload feedback for Design File.
// 3. Required-field validation that surfaces error state via aria-invalid +
//    aria-describedby. Hooks into the host product form so missing values are
//    caught at submit time (the customizer inputs live outside <form> and
//    associate via the HTML form= attribute). Error message comes from the
//    input's data-validation-message attribute.
// 4. Digitization +$15 line-item add-on. When the user selects "Needs
//    digitization" and submits the form, this listener adds the
//    `digitization-fee` product as a second cart line item right after Dawn's
//    product-form finishes adding the main product. Requires a product with
//    handle "digitization-fee" priced at $15 to exist in the catalog;
//    main-product.liquid emits window.royalRanchDigitizationFee when it does.

(function () {
  var MAX_FILE_BYTES = 20 * 1024 * 1024; // 20 MB

  function init(root) {
    if (!root || root.dataset.customOptionsBound === 'true') return;
    root.dataset.customOptionsBound = 'true';
    root.querySelectorAll('input[data-validated-text-input]').forEach(function (input) {
      bindCharCounter(input);
      bindRequiredValidation(input);
    });
    bindFileFeedback(root);
  }

  function findDescribedBy(input, suffix) {
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/);
    for (var i = 0; i < ids.length; i++) {
      if (ids[i].indexOf(suffix) !== -1) return document.getElementById(ids[i]);
    }
    return null;
  }

  function bindCharCounter(input) {
    var counter = findDescribedBy(input, 'Counter');
    if (!counter) return;
    var max = parseInt(input.getAttribute('maxlength'), 10) || 60;
    function render() {
      var len = input.value.length;
      counter.textContent = len + ' / ' + max + ' characters';
      counter.classList.toggle('custom-options__counter--limit', len >= max);
    }
    input.addEventListener('input', render);
    render();
  }

  function bindFileFeedback(root) {
    var input = root.querySelector('input[type="file"][name="properties[Design File]"]');
    var feedback = root.querySelector('[data-file-feedback]');
    if (!input || !feedback) return;
    input.addEventListener('change', function () {
      feedback.removeAttribute('data-state');
      feedback.textContent = '';
      var file = input.files && input.files[0];
      if (!file) return;
      if (file.size > MAX_FILE_BYTES) {
        feedback.setAttribute('data-state', 'error');
        feedback.textContent = file.name + ' is too large (max 20 MB). Choose a smaller file.';
        input.value = '';
        return;
      }
      feedback.setAttribute('data-state', 'success');
      feedback.textContent = 'Uploaded: ' + file.name + ' (' + formatSize(file.size) + ')';
    });
  }

  function bindRequiredValidation(input) {
    var errorEl = findDescribedBy(input, 'Error');
    var fallbackMessage = input.getAttribute('data-validation-message') || 'This field is required.';

    function clear() {
      input.setAttribute('aria-invalid', 'false');
      if (errorEl) {
        errorEl.removeAttribute('data-active');
        errorEl.textContent = '';
      }
    }

    function flag(message) {
      input.setAttribute('aria-invalid', 'true');
      if (errorEl) {
        errorEl.setAttribute('data-active', 'true');
        errorEl.textContent = message;
      }
    }

    input.addEventListener('invalid', function (e) {
      e.preventDefault();
      flag(input.validationMessage || fallbackMessage);
    });
    input.addEventListener('input', clear);

    var formId = input.getAttribute('form');
    if (!formId) return;
    var form = document.getElementById(formId);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!input.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        flag(input.validationMessage || fallbackMessage);
        input.focus();
      }
    });
  }

  function formatSize(bytes) {
    var kb = bytes / 1024;
    if (kb < 1024) return Math.round(kb) + ' KB';
    return (kb / 1024).toFixed(1) + ' MB';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-custom-options]').forEach(init);
  }

  // --- Digitization fee handling ---------------------------------------------
  // The fee is a separate product in the catalog (handle: digitization-fee, $15).
  // We capture the user's choice at form submit time, let Dawn add the main
  // product normally, then add the fee as a second /cart/add.js call so cart
  // math stays native. If the fee product is missing from the catalog, we log
  // and let the main add proceed without it -- the customizer still submits
  // properties[Digitization] = "Needs digitization (+$15)" so the merchant can
  // see the request even when not auto-charged.

  var pendingFee = null;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    pendingFee = null;
    var digiInput = document.querySelector(
      'input[name="properties[Digitization]"][form="' + form.id + '"]:checked'
    );
    if (!digiInput) return;
    if (digiInput.value.indexOf('Needs digitization') === -1) return;
    if (!window.royalRanchDigitizationFee || !window.royalRanchDigitizationFee.variantId) {
      console.warn(
        '[custom-options] customer requested digitization but no digitization-fee product is configured; fee will not be charged.'
      );
      return;
    }
    pendingFee = {
      formId: form.id,
      productHandle: window.royalRanchDigitizationFee.productHandle || '',
      variantId: window.royalRanchDigitizationFee.variantId,
      timestamp: Date.now(),
    };
  }, true);

  function subscribeWhenReady() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') {
      // pubsub.js / constants.js may not have loaded yet; try again next tick.
      setTimeout(subscribeWhenReady, 50);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  function handleCartUpdate(event) {
    if (!pendingFee) return;
    if (!event || event.source !== 'product-form') return;
    if (Date.now() - pendingFee.timestamp > 10000) {
      pendingFee = null;
      return;
    }
    var fee = pendingFee;
    pendingFee = null;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionsToRender = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sectionsToRender = cart.getSectionsToRender().map(function (s) { return s.id; });
    }

    var body = {
      items: [{
        id: fee.variantId,
        quantity: 1,
        properties: { '_design_for': fee.productHandle },
      }],
    };
    if (sectionsToRender.length) {
      body.sections = sectionsToRender;
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) {
          console.warn('[custom-options] digitization fee add failed:', data);
          return;
        }
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        }
      })
      .catch(function (err) {
        console.warn('[custom-options] digitization fee add error:', err);
      });
  }

  // --- Bootstrap -------------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  subscribeWhenReady();
})();
